export default __webpack_public_path__ + "static/media/RenewedPolicy.c618e17c.svg";